import { Link } from '@tanstack/react-router';

import { HStack, VStack } from '@/components/Layout';
import { LabelApp } from '@/features/app/components/LabelApp/LabelApp';
import { defaultNS, useTranslation } from '@/lib/i18n';

export type SoftwarePreviewData = {
  /**
   * ソフトウェアID
   */
  id: string;
  /**
   * アプリ名
   */
  name: string;
  /**
   * テナント名
   */
  tenantName?: string | null;
  /**
   * アバターURL
   */
  avatarUrl?: string;
};

type Props = {
  /**
   * ソフトウェア情報
   */
  software: SoftwarePreviewData;
  /**
   * 「プロフィールを見る」リンクの表示可否
   */
  showProfileLink?: boolean;
  /**
   * リンク表示テキスト
   */
  linkText?: string;
  /**
   * クラス名
   */
  className?: string;
};

/**
 * ソフトウェアプレビューカードのコンテンツコンポーネント
 */
export function SoftwarePreviewContent({
  software,
  showProfileLink = true,
  linkText,
  className,
}: Props) {
  const { t } = useTranslation(defaultNS);

  return (
    <VStack className={className}>
      <VStack className="gap-2 max-w-2xl">
        <HStack className="items-center gap-2">
          <LabelApp
            name={software.name}
            avatarUrl={software.avatarUrl}
            tenantName={software.tenantName ?? undefined}
          />
        </HStack>
      </VStack>
      {showProfileLink && software.id && (
        <HStack className="mt-2 justify-end">
          <Link
            to="/software/$id"
            params={{ id: software.id }}
            className="flex items-center justify-center font-semibold text-muted-foreground hover:text-primary capitalize"
          >
            {linkText ||
              t('component.appIntegrationPreviewContent.goToProfile')}
          </Link>
        </HStack>
      )}
    </VStack>
  );
}
